/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const ClockArrow16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            d="M8.157 14.7a6.55 6.55 0 002.643-.54 7.004 7.004 0 003.665-3.663A6.612 6.612 0 0015 7.85c0-.94-.179-1.822-.536-2.646A7.008 7.008 0 0010.8 1.536 6.597 6.597 0 008.157 1a6.59 6.59 0 00-2.642.536A6.99 6.99 0 001.846 5.19c-.16.366-.284.743-.372 1.132l-.04.196H.496c-.17 0-.295.036-.377.11a.348.348 0 00-.12.281c.002.115.05.234.145.356l1.557 2.192c.113.155.243.232.391.232.148 0 .276-.077.384-.232l1.572-2.2a.594.594 0 00.137-.348.348.348 0 00-.123-.282c-.085-.073-.212-.11-.38-.11l-.961.001.017-.078a5.639 5.639 0 011.468-2.551 5.593 5.593 0 011.776-1.19 5.491 5.491 0 012.174-.43c.775 0 1.501.144 2.178.433A5.571 5.571 0 0112.11 3.9a5.7 5.7 0 011.198 1.78c.291.676.437 1.4.437 2.17 0 .775-.146 1.5-.437 2.177-.292.677-.69 1.271-1.198 1.783s-1.1.913-1.776 1.202a5.398 5.398 0 01-2.178.426c-.61 0-1.192-.093-1.744-.278a5.64 5.64 0 01-1.519-.779 5.347 5.347 0 01-1.19-1.184.779.779 0 00-.434-.282.588.588 0 00-.476.099.55.55 0 00-.253.412.666.666 0 00.162.518 7.163 7.163 0 003.344 2.407 6.437 6.437 0 002.11.349zm1.804-3.778a.48.48 0 00.215-.366.642.642 0 00-.137-.437L8.46 7.992V4.524a.538.538 0 00-.162-.395.538.538 0 00-.395-.162.55.55 0 00-.398.162.533.533 0 00-.165.395v3.664c0 .08.014.155.042.226.028.07.07.143.127.218l1.614 2.135c.117.15.251.238.401.261a.598.598 0 00.437-.106z"
            fill={vars.bdlGray}
            fillRule="nonzero"
        />
    </AccessibleSVG>
);

export default ClockArrow16;
